import { combineReducers } from 'redux';
import currencyFormatterReducer from './pages/currency-formatter/currency-formatter-reducer';
import emiCalculatorReducer from './pages/emi-calculator/emi-calculator-reducer';
import lumpsumInvestmentCalculatorReducer from './pages/lumpsuminvestment-calculator/lumpsuminvestment-calculator-reducer';
import prepaymentCalculatorReducer from './pages/prepayment-calculator/prepayment-calculator-reducer';
import sipInvestmentCalculatorReducer from './pages/sipinvestment-calculator/sipinvestment-calculator-reducer';


const rootReducer = combineReducers({
  prepaymentCalculator: prepaymentCalculatorReducer,
  currencyDataFormatter: currencyFormatterReducer,
  lumpsumInvestmentCalculator: lumpsumInvestmentCalculatorReducer,
  sipInvestmentCalculator: sipInvestmentCalculatorReducer,
  emiCalculator: emiCalculatorReducer,
});

export default rootReducer;
